import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  TextField,
  Typography,
  Input,
  MenuItem,
  Select,
  Autocomplete,
  Chip,
  FormControl,
  InputLabel,
  Stack,
  Paper,
  FormHelperText,
  Switch,
  FormControlLabel,
  RadioGroup,
  Radio,
  Alert,
} from '@mui/material';
import { Add, Delete } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useFormik, FormikProvider, FieldArray, Form } from 'formik';
import * as Yup from 'yup';
import dayjs from 'dayjs';
import { getCartEditRequests, holdPaymentUpload } from '../../../../../redux/features/generalSlice';
import { Icon } from '@iconify/react';
import { pdfjs, Document, Page } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';
import { useSelector } from 'react-redux';
import useResponsive from '../../../../../Hooks/useResponsive';
import { UpdateCartData } from '../../../../../redux/features/cartSlice';
import { useSnackbar } from 'notistack';
import Loader3D from '../../../../../components/Loader/Loader3D';
import DeleteCourse from './DeleteCourse';
import { CART_AED_TO_INR_VALUE } from '../../../../../utils/constants/GlobalStaticData';
import GlobalSelectFieldWithoutFormikNew from '../../../../../components/mui/GlobalSelectFieldWithoutFormikNew';

// Example API call function
const uploadFile = async (file, dispatch) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const response = await dispatch(holdPaymentUpload(file));

    return response.payload.data.filename;
  } catch (error) {
    console.error('File upload failed:', error);
    return '';
  }
};

const levelOptions = ['level 1', 'level 2', 'level 3', 'level 4', 'level 5', 'Basic', 'Intermediate', 'Advanced'];

const DynamicForm = ({ params, dispatchParams, setOpen }) => {
  const { classes, subjects } = useSelector((state) => state.cro);
  const smUp = useResponsive('up', 'sm');

  const mdUp = useResponsive('up', 'md');
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { cartEditData, loading } = useSelector((state) => state.cart);
  const [saleAmtValidation, setSaleAmtValidation] = useState(false);
  // Tracks rows where <img> failed to decode (e.g. HEIC/webp the browser can't render inline)
  // so we can fall back to a direct "open file" link instead of a broken image / wrong PDF viewer.
  const [screenshotLoadError, setScreenshotLoadError] = useState({});
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

  const enrollmentIdRef = useRef(null);

  useEffect(() => {
    enrollmentIdRef.current = cartEditData?.courseEnrollmentId ?? params.enrollId ?? null;
  }, [cartEditData, params.enrollId]);

  const defaultFields = {
    mrp: false,
    discount: false,
    emiStatus: false,
    screenshot: false,
    incomeAmount: false,
    incomeAmountAed: false,
    incomeType: false,
    paymentMethod: false,
    transactionDate: false,
    paymentAccount: false,
    remarks: false,
    levelOpted: false,
    booksAndPub: false,
    prefChapter: false,
    currClass: false,
    subjectAndSession: false,
    subject: false,
    amountInr: false,
    amountAed: false,
  };

  const initialValues = {
    financeDetails: cartEditData?.financeDetails || [
      {
        incomeAmount: '',
        incomeAmountAed: '',
        transactionDate: '',
        paymentAccount: '',
        remarks: '',
        screenshot: '',
        incomeType: '',
        isHoldAmount: '',
        paymentMethod: '',
        sogoRemarks: '',
      },
    ],
    subjectDetails: cartEditData?.subjectDetails || [{ subject: '', amountInr: '', amountAed: '' }],
    fields: cartEditData?.fields ?? defaultFields,
    remarks: cartEditData?.remarks || '',
    levelOpted: cartEditData?.levelOpted || [],
    booksAndPub: cartEditData?.booksAndPub || '',
    prefChapter: cartEditData?.prefChapter || '',
    currClass: cartEditData?.currClass || '',
    subjectAndSession: cartEditData?.subjectAndSession || '',
    reqId: params.reqId,
    enrollId: enrollmentIdRef.current,
    mrp: cartEditData?.mrp || '',
    discount: cartEditData?.discount || '',
    saleAmt: cartEditData?.saleAmt || '',
    emiStatus: cartEditData?.emiStatus ?? 0,
    sogoRemarks: cartEditData?.sogoRemarks || '',
    addedBy: cartEditData?.financeDetails?.[0]?.userID || null,
  };

  console.log(enrollmentIdRef.current, 'IDDDDDDD');

  const getValidationSchema = (cartEditData) =>
    Yup.object().shape({
      financeDetails: Yup.array().of(
        Yup.object().shape({
          incomeAmount: Yup.number().required('Required'),
          incomeAmountAed: cartEditData?.currencyType === 2 ? Yup.number().required('Required') : Yup.number(),
          transactionDate: Yup.string().required('Required'),
          paymentAccount: Yup.string().required('Required'),
          isHoldAmount: Yup.mixed().when('incomeType', {
            is: 'Tuition Fee',
            then: (schema) => schema.oneOf([true, false], 'Select Normal Income or Hold Amount').required('Select Normal Income or Hold Amount'),
            otherwise: (schema) => schema.notRequired(),
          }),
          // remarks: Yup.string().required('Required'),
          // screenshot: Yup.string().when([], {
          //   is: () => cartEditData?.paymentMethod !== 'Link',
          //   then: (schema) => schema.required('Proof required'),
          //   otherwise: (schema) => schema.notRequired(),
          // }),
        }),
      ),
      // subjectDetails: Yup.array().of(
      //   Yup.object().shape({
      //     subject: Yup.string().required('Required'),
      //     amountInr: Yup.number().required('Required'),
      //     amountAed: cartEditData?.currencyType === 2 ? Yup.number().required('Required') : Yup.number(),
      //   })
      // ),
      // remarks: Yup.string().required('Required'),
      // levelOpted: Yup.array().min(1, "Select at least one level"),
      // booksAndPub: Yup.string().required('Required'),
      // prefChapter: Yup.string().required('Required'),
      // currClass: Yup.string().required('Required'),
      // subjectAndSession: Yup.string().required('Required'),
    });

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validationSchema: getValidationSchema(cartEditData),
    onSubmit: (values) => {
      dispatch(UpdateCartData(values)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
          enrollmentIdRef.current = null;
          setOpen(false);
          dispatch(getCartEditRequests(dispatchParams));
        } else if (res.payload.status === 'error' || res.payload.status === 'failed') {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
          enrollmentIdRef.current = null;
        }
      });
    },
  });

  // -----------------------------------------------------

  useEffect(() => {
    if (cartEditData) {
      const { saleAmt, currencyType, subjectDetails } = cartEditData;
      const Mrp = formik.values.mrp;
      let total = 0;

      if (Array.isArray(formik.values.subjectDetails)) {
        if (currencyType === 1) {
          total = formik.values.subjectDetails.reduce((sum, item) => sum + Number(item.amountInr || 0), 0);
        } else if (currencyType === 2) {
          total = formik.values.subjectDetails.reduce((sum, item) => sum + Number(item.amountAed || 0), 0);
        } else if (currencyType === 3) {
          total = formik.values.subjectDetails.reduce((sum, item) => sum + Number(item.amountInr || 0), 0);
        }
      }

      // ✅ Validation
      // if (Mrp == total) {
      //   setSaleAmtValidation(false);
      // } else {
      //   setSaleAmtValidation(true);
      // }
    }
  }, [cartEditData, formik.values.subjectDetails, formik.values.mrp]);
  // ---------------------------------------------------------------

  const { values, errors, touched, handleChange, setFieldValue, handleSubmit } = formik;

  // Same "total income >= first payable amount" rule enforced server-side in cartEditUpdate.
  // firstPayableAmount/totalQualifyingIncome are computed once by the backend (cartEditGet) so
  // this stays in sync with the option-based/percentage-based plan the course actually locked in.
  // EMI courses don't have that plan - EMI means paying in smaller installments over time, so
  // cartEditUpdate skips this floor once EMI is on; mirrored here so the Save button doesn't
  // stay disabled on this rule for an EMI course. `values.emiStatus` already reflects the live
  // toggle state (it's seeded from cartEditData?.emiStatus and updated on check/uncheck).
  const isEmiEnabled = values.emiStatus === 1;
  const firstPayableAmount = isEmiEnabled ? 0 : (Number(cartEditData?.firstPayableAmount) || 0);
  const qualifyingIncomeAmt = (income) => {
    if (!income || ['EMI Processing Fee', 'Admission Fee'].includes(income.incomeType)) return 0;
    return cartEditData?.currencyType === 2 && Number(income.incomeAmountAed)
      ? Number(income.incomeAmountAed)
      : Number(income.incomeAmount) || 0;
  };
  const prevQualifyingTotal = (cartEditData?.financeDetails || []).reduce((sum, i) => sum + qualifyingIncomeAmt(i), 0);
  const newQualifyingTotal = (values.financeDetails || []).reduce((sum, i) => sum + qualifyingIncomeAmt(i), 0);
  const totalIncomeAfterEdit = (Number(cartEditData?.totalQualifyingIncome) || 0) - prevQualifyingTotal + newQualifyingTotal;
  const firstPayableCurrencyLabel = cartEditData?.currencyType === 2 ? 'AED' : 'INR';
  const firstPayableShortfallError =
    firstPayableAmount > 0 && totalIncomeAfterEdit < firstPayableAmount - 1
      ? `Total income (${Math.round(totalIncomeAfterEdit)}) must be greater than or equal to the first payable amount (${Math.round(
          firstPayableAmount,
        )})`
      : '';

  // Operational control: the OGA/SOGO who owns this course (or their reporting head) may add only
  // ONE non-hold "Tuition Fee" income entry — unlimited Hold Amount entries are still allowed.
  // Mirrors cartEditUpdate's server-side enforcement so the UI reflects the same rule live.
  const countNormalTuitionFeeEntries = (list) =>
    (list || []).filter((i) => i.incomeType === 'Tuition Fee' && i.isHoldAmount === false).length;
  const prevNormalTuitionFeeCount = countNormalTuitionFeeEntries(cartEditData?.financeDetails);
  const newNormalTuitionFeeCount = countNormalTuitionFeeEntries(values.financeDetails);
  const existingNormalTuitionFeeCount = Number(cartEditData?.existingNormalTuitionFeeCount) || 0;
  const finalNormalTuitionFeeCount = existingNormalTuitionFeeCount - prevNormalTuitionFeeCount + newNormalTuitionFeeCount;
  // Flags when a row actually BECOMES Normal (new row, or an existing Hold row flipped to
  // Normal) — not just on the net total — so reclassifying one Normal row to Hold while adding
  // a fresh Normal row can't slip past as "no net increase". Never blocks purely because
  // pre-existing data was already over the cap and untouched by this edit.
  const didAnyRowBecomeNormalTuitionFee = (previousList, newList) => {
    const prevByIncomeId = new Map((previousList || []).filter((i) => i.incomeId).map((i) => [i.incomeId, i]));
    return (newList || []).some((item) => {
      if (item.incomeType !== 'Tuition Fee' || item.isHoldAmount !== false) return false;
      const prevItem = item.incomeId ? prevByIncomeId.get(item.incomeId) : undefined;
      return !prevItem || prevItem.isHoldAmount !== false;
    });
  };
  const becameNormalTuitionFee = didAnyRowBecomeNormalTuitionFee(cartEditData?.financeDetails, values.financeDetails);
  const normalTuitionFeeCapError =
    cartEditData?.isRestrictedForNormalIncomeCap && finalNormalTuitionFeeCount > 1 && becameNormalTuitionFee
      ? 'Only one normal (non hold amount) Tuition Fee income entry is allowed for this course — add the rest as Hold Amount.'
      : '';

  if (loading) return <Loader3D />;
  return (
    <FormikProvider value={formik}>
      <Form onSubmit={handleSubmit}>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <DeleteCourse cartId={cartEditData?.cartId} />
        </Box>
        <Box>
          {/* Currency Toggle */}
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              size="small"
              variant={cartEditData?.currencyType === 1 ? 'contained' : 'outlined'}
              // onClick={() => setCurrencyFlag(1)}
              sx={{ mr: 2, borderRadius: 4 }}
            >
              INR
            </Button>
            <Button
              size="small"
              variant={cartEditData?.currencyType === 2 ? 'contained' : 'outlined'}
              // onClick={() => setCurrencyFlag(2)}
              sx={{ mr: 2, borderRadius: 4 }}
            >
              AED
            </Button>
            <Button
              size="small"
              variant={cartEditData?.currencyType === 3 ? 'contained' : 'outlined'}
              // onClick={() => setCurrencyFlag(2)}
              sx={{ mr: 2, borderRadius: 4 }}
            >
              AED to INR
            </Button>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
            <FormControlLabel
              control={
                <Switch
                  disabled={cartEditData?.currencyType === 2 || values.fields.emiStatus ? true : false}
                  checked={formik?.values.emiStatus === 1 ? true : false}
                  onChange={(event) => {
                    setFieldValue('emiStatus', event.target.checked ? 1 : 0);
                  }}
                />
              }
              label="EMI"
            />
            {/* 
            <FormControlLabel
              control={
                <Switch
                  disabled={cartEditData?.currencyType === 2 || values.fields.processingFee ? true : false}
                  checked={formik?.values.processingFee === 1 ? true : false}
                  onChange={(event) => {
                    setFieldValue('processingFee', event.target.checked ? 1 : 0);
                  }}
                />
              }
              label="Processing Fee"
            />
            <FormControlLabel
              control={
                <Switch
                  disabled={values.fields.admissionFee ? true : false}
                  checked={formik?.values.admissionFee === 1 ? true : false}
                  onChange={(event) => {
                    setFieldValue('admissionFee', event.target.checked ? 1 : 0);
                  }}
                />
              }
              label="Admission Fee"
            /> */}
          </Box>

          {/* Finance Details */}
          <Typography sx={{ pl: 2 }} variant="h6" gutterBottom>
            Finance Details
          </Typography>
          {firstPayableAmount > 0 ? (
            <Box sx={{ pl: 2, mb: 1 }}>
              <Chip
                size="small"
                variant="outlined"
                color={firstPayableShortfallError ? 'error' : 'success'}
                label={`First payment (Tuition Fee) required: ${Math.round(
                  firstPayableAmount,
                )} ${firstPayableCurrencyLabel} — Currently: ${Math.round(totalIncomeAfterEdit)} ${firstPayableCurrencyLabel}`}
              />
            </Box>
          ) : null}

          <FieldArray name="financeDetails">
            {({ push, remove }) => (
              <>
                {values.financeDetails.map((item, index) => (
                  <Box key={index} width={'100%'} mt={2} sx={{ borderRadius: 4 }} component={Paper}>
                    <Stack direction={smUp ? 'row' : 'column'} spacing={2} sx={{ p: 2 }}>
                      <Box>
                        <Box
                          sx={{
                            borderRadius: 3,
                            border: '2px dashed',
                            borderColor: 'divider',
                          }}
                          component={Paper}
                          elevation={3}
                        >
                          {values.financeDetails?.[index]?.paymentMethod === 'Link' ? (
                            <Box
                              sx={{
                                height: 400,
                                width: 250,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Typography>LINK PAYMENT</Typography>
                            </Box>
                          ) : !item.screenshot ? (
                            <Box
                              sx={{
                                height: 400,
                                width: 250,
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                              }}
                            >
                              <Typography color="text.secondary">No screenshot uploaded</Typography>
                            </Box>
                          ) : (
                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                              {item.screenshot?.match(/\.pdf$/i) ? (
                                // Render PDF Viewer
                                <div style={{ textAlign: 'center' }}>
                                  <Document
                                    file={`${process.env.REACT_APP_UPLOADS_URL}${item.screenshot}`}
                                    onLoadSuccess={onDocumentLoadSuccess}
                                    loading="Loading PDF..."
                                  >
                                    <Page pageNumber={pageNumber} width={300} />
                                  </Document>

                                  <p>
                                    Page {pageNumber} of {numPages}
                                  </p>
                                  <div>
                                    <button
                                      onClick={() => setPageNumber((prev) => Math.max(prev - 1, 1))}
                                      disabled={pageNumber === 1}
                                    >
                                      Previous
                                    </button>
                                    <button
                                      onClick={() => setPageNumber((prev) => Math.min(prev + 1, numPages))}
                                      disabled={pageNumber === numPages}
                                    >
                                      Next
                                    </button>
                                  </div>
                                </div>
                              ) : screenshotLoadError[index] ? (
                                // The browser couldn't decode this as an image (e.g. HEIC/webp) —
                                // offer a direct link instead of a blank/broken preview.
                                <Box
                                  sx={{
                                    height: 400,
                                    width: 250,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: 1,
                                  }}
                                >
                                  <Typography color="text.secondary" align="center">
                                    Preview not available
                                  </Typography>
                                  <a
                                    href={`${process.env.REACT_APP_UPLOADS_URL}${item.screenshot}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Open file
                                  </a>
                                </Box>
                              ) : (
                                // Render Image — any format the upload accepted (jpg/png/gif/webp/heic/...),
                                // falling back to the "Preview not available" link above on decode failure.
                                <img
                                  style={{
                                    borderRadius: '30px',
                                    height: 400,
                                    width: 250,
                                    padding: '4px',
                                  }}
                                  src={`${process.env.REACT_APP_UPLOADS_URL}${item.screenshot}`}
                                  alt="Screenshot"
                                  onError={() => setScreenshotLoadError((prev) => ({ ...prev, [index]: true }))}
                                />
                              )}
                            </Box>
                          )}

                          {/* --------------------- */}
                        </Box>
                        <Box pt={1} display="flex" justifyContent={'center'} alignItems="center">
                          <label htmlFor={`file-upload-${index}`}>
                            <Box
                              component="span"
                              sx={{
                                cursor: 'pointer',
                                padding: '3px 6px',
                                background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                                color:
                                  values.fields.screenshot && values.financeDetails?.[index]?.incomeId
                                    ? 'gray.500'
                                    : 'white',
                                borderRadius: '30px',
                                display: 'inline-block',
                              }}
                            >
                              Update Payment Proof
                            </Box>
                          </label>
                          <Input
                            disabled={values.fields.screenshot && values.financeDetails?.[index]?.incomeId}
                            id={`file-upload-${index}`}
                            type="file"
                            sx={{ display: 'none' }}
                            inputProps={{ accept: '.pdf,image/*' }}
                            onChange={async (e) => {
                              const file = e.currentTarget.files[0];
                              if (file) {
                                const fileKey = await uploadFile(file, dispatch);
                                if (fileKey) {
                                  setFieldValue(`financeDetails[${index}].screenshot`, fileKey);
                                }
                              }
                            }}
                          />
                        </Box>
                      </Box>
                      <Box
                        width={'100%'}
                        sx={{
                          backgroundColor: 'grey.200',
                          p: 2,
                          borderRadius: 4,
                        }}
                      >
                        <Box pb={2}>
                          <Chip
                            icon={<Icon icon="stash:payment-link" width="24" height="24" />}
                            color="primary"
                            variant="outlined"
                            label={'Payment Details'}
                          />
                        </Box>
                        <Box pb={2}>
                          <FormControl fullWidth>
                            <InputLabel id={`added-by-label-${index}`} shrink>
                              Added By
                            </InputLabel>
                            <Select
                              fullWidth
                              labelId={`added-by-label-${index}`}
                              label="Added By"
                              displayEmpty
                              onChange={(e) => {
                                setFieldValue(`financeDetails[${index}].userID`, e.target.value);
                              }}
                              value={values.financeDetails?.[index]?.userID || ''}
                              renderValue={(selected) => {
                                if (!selected) {
                                  return <Typography color="warning.main">No user selected</Typography>;
                                }
                                const match = cartEditData?.courseRelatedDrop?.find((u) => u.userID === selected);
                                return match?.name || `Unknown user (ID ${selected})`;
                              }}
                            >
                              <MenuItem value="">
                                <em>No user selected</em>
                              </MenuItem>
                              {cartEditData?.courseRelatedDrop?.map?.((item) => (
                                <MenuItem key={item.userID} value={item.userID}>
                                  {item.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Box>

                        <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
                          <TextField
                            fullWidth
                            label="Income Amount"
                            disabled={
                              values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                              cartEditData?.currencyType === 2 ||
                              (values.fields.incomeAmount && values.financeDetails?.[index]?.incomeId)
                                ? true
                                : false
                            }
                            name={`financeDetails[${index}].incomeAmount`}
                            value={item.incomeAmount}
                            onChange={handleChange}
                            error={
                              touched.financeDetails?.[index]?.incomeAmount &&
                              Boolean(errors.financeDetails?.[index]?.incomeAmount)
                            }
                            helperText={
                              touched.financeDetails?.[index]?.incomeAmount &&
                              errors.financeDetails?.[index]?.incomeAmount
                            }
                          />

                          {cartEditData?.currencyType === 2 && (
                            <TextField
                              fullWidth
                              label="Income AED"
                              name={`financeDetails[${index}].incomeAmountAed`}
                              value={item.incomeAmountAed}
                              disabled={
                                values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                                (values.fields.incomeAmountAed && values.financeDetails?.[index]?.incomeId)
                                  ? true
                                  : false
                              }
                              onChange={(e) => {
                                const value = parseFloat(e.target.value || 0);
                                setFieldValue(`financeDetails[${index}].incomeAmountAed`, value);
                                setFieldValue(`financeDetails[${index}].incomeAmount`, value * CART_AED_TO_INR_VALUE);
                              }}
                              error={
                                touched.financeDetails?.[index]?.incomeAmountAed &&
                                Boolean(errors.financeDetails?.[index]?.incomeAmountAed)
                              }
                              helperText={
                                touched.financeDetails?.[index]?.incomeAmountAed &&
                                errors.financeDetails?.[index]?.incomeAmountAed
                              }
                            />
                          )}
                        </Stack>
                        <Stack direction={smUp ? 'row' : 'column'} spacing={2} sx={{ pt: 2 }}>
                          <TextField
                            fullWidth
                            type="date"
                            label="Transaction Date"
                            disabled={
                              values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                              (values.fields.transactionDate && values.financeDetails?.[index]?.incomeId)
                                ? true
                                : false
                            }
                            InputLabelProps={{ shrink: true }}
                            name={`financeDetails[${index}].transactionDate`}
                            value={dayjs(item.transactionDate).format('YYYY-MM-DD')}
                            onChange={handleChange}
                          />

                          <Select
                            fullWidth
                            name={`financeDetails[${index}].paymentAccount`}
                            value={item.paymentAccount}
                            disabled={
                              values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                              (values.fields.paymentMethod && values.financeDetails?.[index]?.incomeId)
                                ? true
                                : false
                            }
                            onChange={handleChange}
                            displayEmpty
                          >
                            <MenuItem value="">Select payment Account</MenuItem>
                            <MenuItem value={1}>Indian a/c</MenuItem>
                            <MenuItem value={2}>GCC a/c</MenuItem>
                          </Select>
                        </Stack>
                        <Box pt={2}>
                          <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
                            <Select
                              fullWidth
                              name={`financeDetails[${index}].incomeType`}
                              value={item.incomeType}
                              onChange={handleChange}
                              disabled={
                                (item.incomeType === 'Admission Fee' && Boolean(item.incomeId)) ||
                                values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                                (values.fields.incomeType && values.financeDetails?.[index]?.incomeId)
                                  ? true
                                  : false
                              }
                              displayEmpty
                            >
                              <MenuItem value="">Select income type</MenuItem>
                              <MenuItem value={'Tuition Fee'}>Tuition Fee</MenuItem>
                              <MenuItem value={'Admission Fee'}>Admission Fee</MenuItem>
                              <MenuItem value={'EMI Processing Fee'}>EMI Processing Fee</MenuItem>
                            </Select>
                            {item.incomeType === 'Tuition Fee' ? (
                              <Box sx={{ width: '100%' }}>
                                <RadioGroup
                                  row
                                  name={`financeDetails[${index}].isHoldAmount`}
                                  value={item.isHoldAmount === true ? 'hold' : item.isHoldAmount === false ? 'normal' : ''}
                                  onChange={(e) =>
                                    setFieldValue(`financeDetails[${index}].isHoldAmount`, e.target.value === 'hold')
                                  }
                                >
                                  <FormControlLabel value="normal" control={<Radio />} label="Normal Income" />
                                  <FormControlLabel value="hold" control={<Radio />} label="Hold Amount" />
                                </RadioGroup>
                                {touched.financeDetails?.[index]?.isHoldAmount &&
                                  errors.financeDetails?.[index]?.isHoldAmount && (
                                    <FormHelperText error>
                                      {errors.financeDetails[index].isHoldAmount}
                                    </FormHelperText>
                                  )}
                              </Box>
                            ) : null}
                            <Select
                              fullWidth
                              name={`financeDetails[${index}].paymentMethod`}
                              value={item.paymentMethod}
                              onChange={handleChange}
                              disabled={
                                values.financeDetails?.[index]?.paymentMethod === 'Link' ||
                                (values.fields.paymentMethod && values.financeDetails?.[index]?.incomeId)
                                  ? true
                                  : false
                              }
                              displayEmpty
                            >
                              <MenuItem value="">Select Method</MenuItem>
                              <MenuItem value={'Cash'}>Cash</MenuItem>
                              <MenuItem value={'Bank Transfer'}>Bank Transfer</MenuItem>
                              <MenuItem value={'EMI'}>EMI</MenuItem>
                              <MenuItem disabled value={'Link'}>
                                Link
                              </MenuItem>
                            </Select>
                          </Stack>
                        </Box>

                        <TextField
                          fullWidth
                          label="Remarks"
                          name={`financeDetails[${index}].remarks`}
                          value={item.remarks}
                          disabled={values.fields.remarks && values.financeDetails?.[index]?.incomeId}
                          multiline
                          sx={{ mt: 2 }}
                          rows={4}
                          onChange={handleChange}
                          error={
                            touched.financeDetails?.[index]?.remarks && Boolean(errors.financeDetails?.[index]?.remarks)
                          }
                          helperText={
                            touched.financeDetails?.[index]?.remarks && errors.financeDetails?.[index]?.remarks
                          }
                        />
                      </Box>
                      {/* --------------------------------------------------------------------------------- */}
                    </Stack>
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                      {/* {values.financeDetails?.[index]?.incomeId ? null : ( */}
                      <IconButton onClick={() => remove(index)} disabled={item.incomeType === 'Admission Fee' && Boolean(item.incomeId)}>
                        <Delete />
                      </IconButton>
                      {/* )} */}
                    </Box>
                  </Box>
                ))}
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  {' '}
                  <Button
                    startIcon={<Add />}
                    onClick={() =>
                      push({
                        incomeAmount: 0,
                        incomeAmountAed: 0,
                        screenshot: '',
                        transactionDate: dayjs().format('YYYY-MM-DD'),
                        incomeType: '',
                        isHoldAmount: '',
                        paymentMethod: '',
                        paymentAccount: '',
                        remarks: '',
                      })
                    }
                    sx={{ mt: 2 }}
                  >
                    Add Finance
                  </Button>
                </Box>
                {firstPayableShortfallError ? (
                  <Box sx={{ mt: 2 }}>
                    <Alert severity="error">{firstPayableShortfallError}</Alert>
                  </Box>
                ) : null}
                {normalTuitionFeeCapError ? (
                  <Box sx={{ mt: 2 }}>
                    <Alert severity="error">{normalTuitionFeeCapError}</Alert>
                  </Box>
                ) : null}
              </>
            )}
          </FieldArray>

          {/* Subject Details */}
          <Box sx={{ backgroundColor: 'grey.200', borderRadius: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ p: 2 }}>
              Subject Details
            </Typography>
            <FieldArray name="subjectDetails">
              {({ push, remove }) => (
                <>
                  {values.subjectDetails.map((item, index) => (
                    <Box key={index} p={2}>
                      <Stack direction={smUp ? 'row' : 'column'} spacing={2}>
                        <Autocomplete
                          fullWidth
                          disabled={values.fields.subject}
                          options={[{ subjectId: -1, subjectName: 'NA' }, ...subjects]}
                          getOptionLabel={(option) => option.subjectName}
                          value={
                            [{ subjectId: -1, subjectName: 'NA' }, ...subjects].find(
                              (option) => option.subjectId === item.subject,
                            ) || null
                          }
                          onChange={(e, newValue) =>
                            setFieldValue(`subjectDetails[${index}].subject`, newValue ? newValue.subjectId : '')
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Subject"
                              error={
                                touched.subjectDetails?.[index]?.subject &&
                                Boolean(errors.subjectDetails?.[index]?.subject)
                              }
                              helperText={
                                touched.subjectDetails?.[index]?.subject && errors.subjectDetails?.[index]?.subject
                              }
                            />
                          )}
                        />

                        <TextField
                          fullWidth
                          label="Amount INR"
                          disabled={cartEditData?.currencyType === 1 || values.fields.amountInr ? false : true}
                          name={`subjectDetails[${index}].amountInr`}
                          value={item.amountInr}
                          onChange={handleChange}
                          error={
                            touched.subjectDetails?.[index]?.amountInr &&
                            Boolean(errors.subjectDetails?.[index]?.amountInr)
                          }
                          helperText={
                            touched.subjectDetails?.[index]?.amountInr && errors.subjectDetails?.[index]?.amountInr
                          }
                        />

                        {cartEditData?.currencyType === 2 && (
                          <TextField
                            fullWidth
                            label="Amount AED"
                            name={`subjectDetails[${index}].amountAed`}
                            value={item.amountAed}
                            disabled={values.fields.amountAed}
                            onChange={(e) => {
                              const value = parseFloat(e.target.value || 0);
                              setFieldValue(`subjectDetails[${index}].amountAed`, value);
                              setFieldValue(`subjectDetails[${index}].amountInr`, value * CART_AED_TO_INR_VALUE);
                            }}
                            error={
                              touched.subjectDetails?.[index]?.amountAed &&
                              Boolean(errors.subjectDetails?.[index]?.amountAed)
                            }
                            helperText={
                              touched.subjectDetails?.[index]?.amountAed && errors.subjectDetails?.[index]?.amountAed
                            }
                          />
                        )}
                      </Stack>
                      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <IconButton onClick={() => remove(index)}>
                          <Delete />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                  {/* <Box p={2}>
                    {saleAmtValidation ? <Alert severity="error">The sale amount does not match...!</Alert> : null}
                  </Box> */}
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      size="small"
                      startIcon={<Add />}
                      onClick={() => push({ subject: '', amountInr: 0, amountAed: 0 })}
                      sx={{
                        mt: 2,
                        background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                        color: 'white',
                        borderRadius: 3,
                        mb: 2,
                      }}
                    >
                      Add Subject
                    </Button>
                  </Box>
                </>
              )}
            </FieldArray>
          </Box>
          {/* ---------------------------------------------------------------------------------------- */}

          {cartEditData?.courseTypeId === 2 ? (
            <Box mt={2}>
              <Stack direction={'column'} spacing={2}>
                <Box>
                  <TextField
                    fullWidth
                    label="MRP"
                    name="mrp"
                    value={values.mrp}
                    disabled={values.fields.mrp}
                    onChange={(e) => {
                      handleChange(e);
                      const newMrp = Number(e.target.value) || 0;
                      const discount = Number(values.discount) || 0;
                      formik.setFieldValue('saleAmt', newMrp - discount);
                    }}
                    error={touched.mrp && Boolean(errors.mrp)}
                    helperText={touched.mrp && errors.mrp}
                  />
                </Box>

                <Box>
                  <TextField
                    fullWidth
                    label="Discount"
                    name="discount"
                    value={values.discount}
                    disabled={values.fields.discount}
                    onChange={(e) => {
                      handleChange(e); // update formik value
                      const newDiscount = Number(e.target.value) || 0;
                      const mrp = Number(values.mrp) || 0;
                      formik.setFieldValue('saleAmt', mrp - newDiscount);
                    }}
                    error={touched.discount && Boolean(errors.discount)}
                    helperText={touched.discount && errors.discount}
                  />
                </Box>
                <Box>
                  <TextField
                    fullWidth
                    label="saleAmt"
                    name="saleAmt"
                    disabled
                    value={values.saleAmt}
                    onChange={handleChange}
                    error={touched.saleAmt && Boolean(errors.saleAmt)}
                    helperText={touched.saleAmt && errors.saleAmt}
                  />
                </Box>
              </Stack>
            </Box>
          ) : null}

          {/* ----------------------------------------------------------------------------------------------- */}

          {/* Level Opted (Multi-Select) */}
          <Box sx={{ mt: 4 }}>
            <Autocomplete
              multiple
              options={levelOptions}
              value={values.levelOpted}
              disabled={values.fields.levelOpted}
              onChange={(e, newValue) => setFieldValue('levelOpted', newValue)}
              renderTags={(tagValue, getTagProps) =>
                tagValue.map((option, index) => <Chip key={index} label={option} {...getTagProps({ index })} />)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Level Opted"
                  error={touched.levelOpted && Boolean(errors.levelOpted)}
                  helperText={touched.levelOpted && errors.levelOpted}
                />
              )}
            />
          </Box>

          {/* Other Fields */}
          <Box sx={{ mt: 4 }}>
            <Box mb={2}>
              <FormControl fullWidth error={touched.currClass && Boolean(errors.currClass)}>
                <InputLabel id="currClass-label">Current Class</InputLabel>
                <Select
                  labelId="currClass-label"
                  disabled={values.fields.currClass}
                  id="currClass"
                  name="currClass"
                  value={values.currClass}
                  onChange={handleChange}
                  // onBlur={handleBlur}
                  label="Current Class"
                >
                  {classes.map((option) => (
                    <MenuItem key={option.classId} value={option.classId}>
                      {option.className}
                    </MenuItem>
                  ))}
                </Select>
                {touched.currClass && errors.currClass && <FormHelperText>{errors.currClass}</FormHelperText>}
              </FormControl>
            </Box>
            <TextField
              fullWidth
              label="Books and Publications"
              name="booksAndPub"
              value={values.booksAndPub}
              disabled={values.fields.booksAndPub}
              onChange={handleChange}
              sx={{ mb: 2 }}
              multiline
              rows={3}
              error={touched.booksAndPub && Boolean(errors.booksAndPub)}
              helperText={touched.booksAndPub && errors.booksAndPub}
            />
            <TextField
              fullWidth
              label="Preferred Chapter"
              name="prefChapter"
              value={values.prefChapter}
              disabled={values.fields.prefChapter}
              onChange={handleChange}
              sx={{ mb: 2 }}
              multiline
              rows={3}
              error={touched.prefChapter && Boolean(errors.prefChapter)}
              helperText={touched.prefChapter && errors.prefChapter}
            />
            <TextField
              fullWidth
              label="Subject and Session"
              name="subjectAndSession"
              value={values.subjectAndSession}
              onChange={handleChange}
              disabled={values.fields.subjectAndSession}
              sx={{ mb: 2 }}
              multiline
              rows={3}
              error={touched.subjectAndSession && Boolean(errors.subjectAndSession)}
              helperText={touched.subjectAndSession && errors.subjectAndSession}
            />
            <TextField
              fullWidth
              label="Remarks"
              name="remarks"
              multiline
              rows={3}
              value={values.remarks}
              onChange={handleChange}
              disabled={values.fields.remarks}
              sx={{ mb: 2 }}
              error={touched.remarks && Boolean(errors.remarks)}
              helperText={touched.remarks && errors.remarks}
            />
            <TextField
              fullWidth
              label="SOGO Remarks"
              name="sogoRemarks"
              multiline
              rows={3}
              value={values.sogoRemarks}
              onChange={handleChange}
              sx={{ mb: 2 }}
              error={touched.sogoRemarks && Boolean(errors.sogoRemarks)}
              helperText={touched.sogoRemarks && errors.sogoRemarks}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button
              type="submit"
              disabled={saleAmtValidation || Boolean(firstPayableShortfallError) || Boolean(normalTuitionFeeCapError)}
              sx={{
                mt: 4,
                background: `linear-gradient(to bottom, #0089d0 0%, #0089d0 10%, #a125c2 100%)`,
                color: 'white',
                borderRadius: 3,
              }}
            >
              <Icon icon="radix-icons:update" width="15" height="15" /> Update details
            </Button>
          </Box>
        </Box>
      </Form>
    </FormikProvider>
  );
};

export default DynamicForm;
